import includes from "lodash/includes";
import isBoolean from "lodash/isBoolean";
import isEmpty from "lodash/isEmpty";
import isNumber from "lodash/isNumber";

const keysToSkip = ["spaces"];

const isEmptyAttribute = (attr) => !isBoolean(attr) && !isNumber(attr) && isEmpty(attr);

const isEmptyPeriod = (attr) => !!attr.period && (!attr.value || parseInt(attr.value, 10) === 0);

const isEmptyCurrency = (attr) =>
  !!attr.currency && (!attr.value || parseInt(attr.value, 10) === 0);

const skip = (key, attr) =>
  includes(keysToSkip, key) ||
  isEmptyAttribute(attr) ||
  isEmptyPeriod(attr) ||
  isEmptyCurrency(attr);

const removeEmptyAttributes = (object) =>
  Object.keys(object).reduce(
    (newObject, key) => ({
      ...newObject,
      [key]: skip(key, object[key]) ? undefined : object[key],
    }),
    {}
  );

const denormalize = (proposal) => ({
  ...removeEmptyAttributes(proposal),
  breakDates: proposal.breakDates ? [proposal.breakDates] : undefined,
  spacesAttributes: proposal.spaces
    ? proposal.spaces.map((space) => removeEmptyAttributes(space)).filter((s) => !isEmpty(s))
    : undefined,
});

export default denormalize;
